import InventoryList from "../../components/Inventory/InventoryList";

function Inventory() {
  return (
    <>
      <InventoryList />
    </>
  );
}

export default Inventory;
